import React from 'react';
import { string, func, bool, number } from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { withRtl } from '../hoc';
import Button from '../Button';
import style from './WaitlistCard.scss';
import CheckCircleIcon from '../icons/CheckCircle';
import Info from '../icons/Info';
import Loader from '../Loader/Loader';
import localMessages from './localMessages';

const WaitlistCard = ({
  handleOnClick,
  title,
  subtitle,
  waitlistPosition,
  priorityGroup,
  waitlistInformation,
  handleQuestionsClick,
  waitlistId,
  hasUnansweredQuestions,
  loading,
  isAdditionalQuestionRequired,
  disabled=false,
  showWaitlistPriorityGroupAndPosition,
  showSiblingQuestion,
  showSiblingsQuestionsForm,
  intl,
}) => (
  <>
    <div className={style.root}>
      <div className={style.leftContainer}>
        <h3>{title}</h3>
        <p className={style.subtitleContainer}>{subtitle}</p>
        {showWaitlistPriorityGroupAndPosition && (
          <div className={style.programDetailsContainer}>
            {waitlistPosition !== null ? (
              <p>
                {intl.formatMessage(localMessages.waitlistCardWaitlistPositionText)}: <b>{waitlistPosition}</b>
              </p>
            ) : (
              <p>
                {intl.formatMessage(localMessages.waitlistCardWaitlistPositionText)}: <b>Your position is being calculated, please check shortly.</b>
              </p>
            )}
            <p>
              {intl.formatMessage(localMessages.waitlistCardPriorityGroupText)}: <b>{priorityGroup}</b>
            </p>
            {waitlistInformation !== null && waitlistInformation !== '' && (
            <p>
            {intl.formatMessage(localMessages.waitlistCardWaitlistInformationText)}: <b>{waitlistInformation}</b>
            </p>
          )}
        </div>
        )}
      </div>
      <div className={style.buttonContainer}>
        <Button
          blueFont
          full
          customClass={style.buttonSize}
          large
          onClick={disabled ? () => {} : handleOnClick}
          disabled={disabled}
          ariaLabel="Remove Program"
          label={''}
        >
          <i className="icon-Remove program-remove" role="presentation" />
        </Button>
      </div>
    </div>

    {isAdditionalQuestionRequired ? (
      hasUnansweredQuestions || (showSiblingQuestion === 'YES' && showSiblingsQuestionsForm) ? (
        <button
          className={classNames(style.questionsAlert, style.unanswered)}
          onClick={disabled ? () => {} : () => handleQuestionsClick(waitlistId)}
          disabled={disabled}
        >
          {loading ? (
            <Loader aria-label="loader" />
          ) : (
            <>
              <Info fill="#fff" size={21} border="#d63d3d" /> Additional questions must be answered to be placed on this
              waitlist
            </>
          )}
        </button>
      ) : (
        <button
          className={classNames(style.questionsAlert, style.answered)}
          onClick={disabled ? () => {} : () => handleQuestionsClick(waitlistId)}
          disabled={disabled}
        >
          <div>
            <CheckCircleIcon fill="#052b52" size={21} /> Additional questions have been answered
          </div>
        </button>
      )
    ) : null}
  </>
);

WaitlistCard.propTypes = {
  handleOnClick: func.isRequired,
  priorityGroup: string.isRequired,
  subtitle: string.isRequired,
  title: string.isRequired,
  waitlistPosition: string.isRequired,
  hasUnansweredQuestions: bool.isRequired,
  isAdditionalQuestionRequired: bool.isRequired,
  loading: bool.isRequired,
  waitlistId: number.isRequired,
  handleQuestionsClick: func.isRequired,
  disabled: bool,
};

export { WaitlistCard };
export default withRtl(style)(withStyles(style)(injectIntl(WaitlistCard)));
